import { createFileRoute } from "@tanstack/react-router";

import UsersGameSessionsIndexPage from "~/pages/gameSession/UsersGameSessionsIndexPage.tsx";

export const Route = createFileRoute("/_auth/game-sessions/")({
    component: UsersGameSessionsIndexPage,
});
